import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const TodaysDrill = ({ drill, isCompleted }) => {
  const navigate = useNavigate();

  const handleStartDrill = () => {
    navigate('/app/daily-drill');
  };

  return (
    <div className="relative overflow-hidden bg-card rounded-3xl shadow-2xl border-2 border-border hover:border-primary/50 transition-all dark:bg-slate-800 dark:border-slate-700">
      {/* Gradient Background Accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-card to-blue-50 opacity-60 dark:from-slate-800 dark:via-slate-800 dark:to-slate-800 dark:opacity-40" />
      
      {/* Content */}
      <div className="relative z-10 p-8">
        <div className="flex items-start justify-between mb-6">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-lg transform -rotate-3 hover:rotate-0 transition-transform">
              <Icon name="Target" size={28} color="#FFFFFF" />
            </div>
            <div>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">
                Today's Drill
              </h2>
              <p className="text-sm text-muted-foreground font-medium">5-10 minute practice session</p>
            </div>
          </div>
          {isCompleted && (
            <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-green-500 to-emerald-500 shadow-lg">
              <Icon name="CheckCircle2" size={18} color="#FFFFFF" />
              <span className="text-sm font-bold text-white">Completed</span>
            </div>
          )}
        </div>

        {/* Drill Content */}
        <div className="mb-6 p-6 bg-muted backdrop-blur-sm rounded-2xl border border-border dark:bg-slate-700 dark:border-slate-600">
          <h3 className="text-lg font-bold text-foreground mb-3">{drill?.title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{drill?.preview}</p>
        </div>

        {/* Metadata Pills */}
        <div className="flex flex-wrap items-center gap-3 mb-6">
          <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-purple-50 border border-purple-200">
            <Icon name="Clock" size={16} color="#9333ea" />
            <span className="text-sm font-semibold text-purple-700">{drill?.duration}</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-50 border border-blue-200">
            <Icon name="BarChart3" size={16} color="#2563eb" />
            <span className="text-sm font-semibold text-blue-700">{drill?.difficulty}</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-indigo-50 border border-indigo-200">
            <Icon name="Briefcase" size={16} color="#4f46e5" />
            <span className="text-sm font-semibold text-indigo-700">{drill?.industry}</span>
          </div>
        </div>

        {/* CTA Button */}
        <button
          onClick={handleStartDrill}
          className={`
            w-full py-4 rounded-2xl font-bold text-base shadow-xl transition-all transform hover:scale-[1.02] active:scale-[0.98]
            flex items-center justify-center gap-3
            ${isCompleted 
              ? 'bg-card border-2 border-primary/50 text-primary hover:bg-muted dark:bg-slate-700 dark:border-primary/50 dark:text-primary dark:hover:bg-slate-600' 
              : 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:from-purple-700 hover:to-indigo-700'
            }
          `}
        >
          <Icon name={isCompleted ? "RotateCcw" : "Play"} size={20} color={isCompleted ? "#7c3aed" : "#FFFFFF"} />
          {isCompleted ? "Practice Again" : "Start Today's Drill"}
        </button>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -top-20 -right-20 w-40 h-40 bg-purple-300/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-blue-300/20 rounded-full blur-3xl" />
    </div>
  );
};

export default TodaysDrill;